/* jQuery.browser.mobile */

(function(a){(jQuery.browser=jQuery.browser||{}).mobile=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))})(navigator.userAgent||navigator.vendor||window.opera);



			var pmgplayer = {
				songid:0,
				load:function(station,feed,nowplaying_feed,autoplay){
					var pthis = this;
					this.nowplaying_feed = nowplaying_feed;

					this.player = document.createElement("audio");
					this.player.setAttribute('src',feed);

					this.station = station;

					if($(window).width() < 305)
					{
						alert("USE OLD PLAYER {redirect}");
					}
					this.nowplaying();
					this.events();
					this.template();
					setTimeout(function(){
						pthis.sponsors(1);
					},2000);
					

					if(autoplay == "1")
						this.play();

				},
				events:function(){
					var pthis = this;

					$(document).on("click","*[data-player='play']",function(){
						pthis.play();
					});

					$(document).on("click","*[data-player='stop']",function(){
						pthis.stop();
					});					

					$(document).on("click","*[data-player='share']",function(e){
						e.preventDefault();
						pthis.share();
					});

					$(document).on("click","*[data-player='popup_close']",function(){
						pthis.popup_close();
					});

					$(document).on("click","*[data-player='popout']",function(e){
						e.preventDefault();
						pthis.popout();
					});					

					$(document).on("click","*[data-player='sponsors']",function(e){
						e.preventDefault();
						pthis.sponsors();
					});					

					$(document).on("click","*[data-player='stations']",function(e){
						e.preventDefault();
						pthis.stations();
					});

					$(document).on("click","*[data-player='sponsors_mobile']",function(e){
						e.preventDefault();
						$("#sponsors").toggleClass("collapsed");
					});

					$(document).on("click","*[data-player='favorite']",function(e){
						e.preventDefault();
						pthis.favorite();
					});

					$(document).on("click","*[data-player='popup_account']",function(e){
						e.preventDefault();
						pthis.popup_account();
					});

					$(document).on("click","*[data-player='favorite_remove']",function(e){
						e.preventDefault();
						pthis.favorite_remove($(this).data("favid"));
					});


					$(document).on("click","*[data-player='popup_favorites']",function(e){
						e.preventDefault();
						pthis.popup_favorites();
					});

					$("#sponsors").hover(function(){
						$("#sponsors").stop(1,0);
					});

					$(window).resize(function(){
						pthis.template();
					});
				},
				play:function(){
					this.player.play();
					this.playing = 1;
					$(".button_play").attr("data-player","stop");
					$(".button_play").addClass("button_pause");
					$(".button_play").addClass("animate");

				},

				stop:function(){
					this.player.pause();
					this.playing = 0;
					$(".button_play").removeClass("button_pause");
					$(".button_play").attr("data-player","play");
					$(".button_play").removeClass("animate");
				},
				nowplaying:function(){
					var pthis = this;

					$.getJSON(AJAX_URL,{'c':'nowplaying','f':'get','station':this.station,'feed':this.nowplaying_feed},function(data){
						pthis.songid = data.songid;
						console.log(data);
						$("*[data-player='nowplaying-artist']").html(data.artist);
						$("*[data-player='nowplaying-song']").html(data.song);
						$("*[data-player='nowplaying-image']").attr("src",data.image);

						if(data.asin)
						{
							$("*[data-player='nowplaying-buylink']").attr("href",data.buylink);
							$(".button_buynow").show();
						}
						else
						{
							$(".button_buynow").hide();
						}

						if(data.favorite)
						{

							$(".button_favorite").addClass("focus");
						}
						else
						{
							$(".button_favorite").removeClass("focus");
						}
					});

					setTimeout(function(){
						pthis.nowplaying();
					},20000);
				},
				share:function(){
					$("#blackout").slideDown('fast');
					var popup_top = ($(window).height() - $("#popup_share").height()) / 2;
					var popup_left = ($(window).width() - $("#popup_share").width()) / 2;
					if($(window).width() < 500)
						popup_left = 0;
					$("#popup_share").css({'left':popup_left,'top':popup_top});
					$("#popup_share").slideDown('fast');
				},
				popup_close:function()
				{
					$("#blackout").slideUp('fast');
					$(".popup").slideUp('fast');
				},
				popout:function(){
					this.stop();
					window.open('//streamhawaii.com/player_beta.php?autoplay=1&s='+this.station,'player',"width=400,height=400,location=0,menubar=0,scrollbars=0,status=0,toolbar=0,resizable=0");
				},
				sponsors:function(firsttime){
					$("#sponsors").stop(1,1);
					var pthis = this;
					var topoffset = 190;
					if($(window).width() < 600)
					{
						var topoffset = 285;
					}
					$("#sponsors").css("height",$(window).height() - topoffset);
					if($(".button_sponsors").hasClass("expanded"))
					{
						$("#sponsors").slideUp('fast');
						$(".button_sponsors").removeClass("expanded");
					}
					else
					{

						$("#sponsors").slideDown('fast',function(){
							if(firsttime)
							{
								
								
									pmgplayer.sponsors_scroll();
								
							}
						});
						$(".button_sponsors").addClass("expanded");
						if(firsttime)
						{
							setTimeout(function(){
							//	adserver_r.show(18,39,43); 
							//	adserver_r.show(18,39,43); 
							//	adserver_r.show(18,39,43); 	
							//	adserver_r.load(); 

							},200);
							
						}
							
					}
				},
				sponsors_scroll:function(){
					$("#sponsors").stop(1,1);
					$("#sponsors").scrollTop(0);
					var scrollbottom = 900 - $("#sponsors").height();
					
					$("#sponsors").animate({'scrollTop':scrollbottom},8000,function(){
						$("#sponsors").stop(1,1);
						$("#sponsors").animate({'scrollTop':'0'},8000);
					});
				},
				template:function(){
					var window_width = $(window).width();
					var window_height = $(window).height();

					// Background Image Size
					if(window_width > window_height)
					{
						var background_size = window_width + "px auto";
					}
					else
					{
						var background_size = "auto " + window_height + "px";	
					}

					$("body").css("background-size",background_size);


					if(jQuery.browser.mobile)
					{
						$(".button_popout").hide();
					}
					else
					{
						$(".button_popout").show();
						if(!$("#vidbg").length && window_width >600)
							$("body").prepend('<video id="vidbg" src="'+HOME_URL+'images/vidbg_sunset.mp4" autoplay controls="0" loop="1" muted></video>');
					}

					if(window_width <= 600)
					{
						$("#vidbg").remove();
						$(".button_popout").hide();
					}



				},
				stations:function(){
					$("#blackout").slideDown('fast');
					var popup_top = ($(window).height() - $("#popup_stations").height()) / 2;
					var popup_left = ($(window).width() - $("#popup_stations").width()) / 2;
					if($(window).width() < 500)
						popup_left = 0;
					$("#popup_stations").css({'left':popup_left,'top':popup_top});
					$("#popup_stations").slideDown('fast');
				},
				favorite:function(){
					if(this.songid)
					{
						$.getJSON(AJAX_URL,{'c':'favorites','f':'update','songid':this.songid},function(data){
							//alert(data.message);
							if(data.message == "Favorite Removed")
								$("*[data-player='favorite']").removeClass("focus");
							else
								$("*[data-player='favorite']").addClass("focus");
						});
					}
				},
				popup_account:function(){
					
					var favorites_width = $(window).width() - 340;
					var favorites_height = $(window).height() - 240;

					if($(window).width() < 600)
					{
						favorites_width = $(window).width();
						favorites_height = $(window).height() - 285;
					}

					$("#popup_favorites").css({"width":favorites_width,"height":favorites_height});
					$("body, html").animate({'scrollTop':'0'},'fast');
					$("#popup_favorites").slideDown('fast');
					$("#popup_favorites .content").html("<center><img src='//mauinow.com/loader.gif' style='padding-top:20px;'></center>");
					this.popup_account_load();
				},
				popup_account_load:function(){
					$.get(HOME_URL + "account.php",function(data){
						$("#popup_favorites .content").html(data);	
					});	
				},
				popup_favorites:function(){
					var favorites_width = $(window).width() - 340;
					var favorites_height = $(window).height() - 240;

					if($(window).width() < 600)
					{
						favorites_width = $(window).width();
						favorites_height = $(window).height() - 285;
					}

					$("#popup_favorites").css({"width":favorites_width,"height":favorites_height});
					$("body, html").animate({'scrollTop':'0'},'fast');
					$("#popup_favorites").slideDown('fast');
					$("#popup_favorites .content").html("<center><img src='//mauinow.com/loader.gif' style='padding-top:20px;'></center>");
					this.popup_favorites_load();
				},
				popup_favorites_load:function(){
					$.getJSON(AJAX_URL,{'c':'favorites','f':'getlist'},function(data){
						var i = 0;
						var innerHTML = "<table>";
						while(data[i])
						{
							var songinfo = data[i];
							innerHTML += "<tr data-favid='"+songinfo.favid+"'><td><img class='album' src='"+songinfo.image+"'></td><td><small>"+songinfo.artist+"</small>"+songinfo.song+"</td><td><img class='station' src='images/logo_"+songinfo.station+".png'></td>";


							innerHTML += "<td>";

							if(songinfo.asin)
							{
								innerHTML += "<a href='"+songinfo.buylink+"' target='_blank'><img src='images/icon_buy.png' class='buylink'></a>";	
							}
							

							innerHTML += "</td><td><a href='#' data-favid='"+songinfo.favid+"' data-player='favorite_remove' class='delete'>&times; Remove</a></td></tr>";
							
							i++;
						}

						if(!data.length)
						{
							innerHTML += "<tr><td><center>You Have Not Saved any Favorites</td></tr>";
						}

						innerHTML += "</table>";
						$("#popup_favorites .content").html(innerHTML);
					});
				},
				favorite_remove:function(favid)
				{
					$.getJSON(AJAX_URL,{'c':'favorites','f':'remove','favid':favid},function(data){
						$("#popup_favorites tr[data-favid='"+favid+"']").fadeOut('fast');
					});
				}

			};